import React from 'react';

import DashboardTopBarContent from './DashboardTopBarContent';

import InviteUserToEventModal, {
  useOpenInviteUserToEventModal,
} from './InviteUserToEventModal';

const DashboardTopBar = () => {
  const {
    open: isOpenedInviteUserModal,
    openModal: openInviteUserModal,
    closeModal: closeInviteUserModal,
  } = useOpenInviteUserToEventModal();

  return (
    <>
      <DashboardTopBarContent onOpenInviteUserModal={openInviteUserModal} />

      {isOpenedInviteUserModal ? (
        <InviteUserToEventModal
          open={isOpenedInviteUserModal}
          onClose={closeInviteUserModal}
        />
      ) : null}
    </>
  );
};

export default DashboardTopBar;
